<template>
    <div>
        <!-- İlk adım: Upgrade türü seçimi -->
        <div class="row justify-content-center" v-if="activeStep == 0">
            <!-- Plan Upgrade seçeneği -->
            <div class="col-md-6 col-lg-6 col-sm-12" v-if="licenceList.length > 0" :class="{'col-lg-12': userData.package_type == 0}">
                <a href="#" class="card hover-elevate-up shadow-sm bg-light-primary border border-primary border-dashed parent-hover" @click="onNextStep('upgradePlan')">
                    <div class="card-body d-flex flex-column flex-center">                        
                        <h1 class="text-gray-800 text-center lh-lg">           
                             {{ $t('upgrade_plan') }} 
                        </h1>
                        <div class="py-10 text-center">
                            <img src="assets/theme/media/svg/illustrations/easy/3.svg" class="theme-light-show w-150px h-100px" alt="">
                            <img src="assets/theme/media/svg/illustrations/easy/3-dark.svg" class="theme-dark-show w-150px h-100px" alt="">
                        </div>
                    </div>
                </a>
            </div>
            
            <!-- Kullanıcı ekleme seçeneği -->
            <div class="col-md-6 col-lg-6 col-sm-12" v-if="userData.package_type !== 0" :class="{'col-lg-12': licenceList.length == 0}">
                <a href="#" class="card hover-elevate-up shadow-sm bg-light-info border border-info border-dashed parent-hover" @click="onNextStep('addUser')">
                    <div class="card-body d-flex flex-column flex-center">                        
                        <h1 class="text-gray-800 text-center lh-lg">           
                             {{ $t('add_user_to_plan') }} 
                        </h1>
                        <div class="py-10 text-center">
                            <img src="assets/theme/media/svg/illustrations/easy/2.svg" class="theme-light-show w-150px h-100px" alt="">
                            <img src="assets/theme/media/svg/illustrations/easy/2-dark.svg" class="theme-dark-show w-150px h-100px" alt="">
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- Stepper arayüzü -->
        <div v-if="activeStep > 0" class="stepper stepper-links" data-kt-stepper="true">
            <!-- Mevcut plan bilgisi -->
            <div class="card p-1 shadow-sm">
                <div class="card-header border-0 min-h-30px">
                    <div class="card-title">
                        <div class="card-label fs-5 text-gray-800">
                            {{ $t('your_current_plan_is') }} <b class="fw-boldest">{{ $t('licences.' + userData.licence_name) }}. </b>
                            <span v-html="$t('active_users_count', { count: userData.user_count })"></span>
                        </div>
                    </div>
                    <div class="card-toolbar" v-if="userData.payment_type == 2">                                    
                        <span class="fs-5 fw-bolder" v-if="userData.period_end > 0">
                            <span v-html="$t('expires_in_days', {
                            class: userData.period_end <= 15 ? 'text-danger' : '',
                            days: userData.period_end
                            })"></span>
                        </span>
                        <span class="text-danger fs-5 fw-bolder" v-if="userData.period_end < 0"> 
                            Expired {{Math.abs(userData.period_end)}} days ago
                        </span>
                        <span class="text-danger fs-5 fw-bolder" v-if="userData.period_end == 0">  
                            {{ $t('expired_today') }} 
                        </span>  
                    </div>
                </div>
            </div>

            <!-- Ana içerik kartı -->
            <div class="card mt-5 p-1 shadow-sm">                
                <div class="card-body bgi-no-repeat bgi-position-y-top bgi-position-x-end ribbon ribbon-top bg-abstract-1">
                    <!-- Kalan süre uyarısı -->
                    <div class="ribbon-label bg-primary" v-if="shouldShowRemainingTimeWarning"> 
                        {{ $t('the_remaining_userdata_period_end_day_will_be_added', [userData.period_end]) }}
                    </div>

                    <!-- 1. Adım: Plan seçimi -->
                    <div class="d-flex flex-column" v-if="activeStep == 1">
                        <div class="text-center">
                            <h1 class="fs-2hx fw-bold mb-3" v-if="activeView == 'upgradePlan'">{{$t('choose_your_plan')}}</h1>
                            <h1 class="fs-2hx fw-bold mb-3" v-if="activeView == 'addUser'">{{$t('add_user_to_your')}}</h1>
                            <div class="text-gray-600 fw-semibold fs-5 mb-3" v-if="isViewLicenceGuid">
                                 {{ $t('if_you_need_more') }}  
                                <a href="#" class="link-primary fw-bold" @click="openHelpPage()" > 
                                    {{ $t('licence_plans_guidelines') }} 
                                </a>.
                            </div>
                        </div>

                        <!-- Ödeme periyodu seçimi -->
                        <div class="nav-group nav-group-outline mx-auto mb-5" v-if="activeView == 'upgradePlan'">
                            <!-- <button class="btn btn-color-gray-600 btn-active btn-active-primary px-6 py-3" 
                                @click="activePriceView = 'annual'" :class="{'active': activePriceView == 'annual'}">
                                 {{ $t('annual') }}  
                                 <span class="badge badge-light-success ms-2"> {{ $t('best_value') }} </span>
                            </button> -->
                            <button class="btn btn-color-gray-600 btn-active btn-active-primary px-6 py-3 me-2" 
                                @click="activePriceView = 'monthly'" :class="{'active': activePriceView == 'monthly'}">
                                 {{ $t('monthly') }} 
                            </button>
                        </div>

                        <!-- Plan kartları -->
                        <div class="d-flex flex-row row g-10 justify-content-center" v-if="activeView == 'upgradePlan'">
                            <div class="d-flex flex-column flex-row-auto col-xl-4 col-md-4" v-for="item in licenceList" :key="item.id">
                                <div class="d-flex card h-100 align-items-start d-flex flex-column-fluid ribbon ribbon-top plan-card"
                                    :class="{'selected': selectedLicence && selectedLicence.id === item.id}">
                                    <!-- Mevcut plan etiketi -->
                                    <div class="ribbon-label bg-info" v-if="item.package_type == userData.package_type"> 
                                        {{ $t('current_plan') }} 
                                    </div>

                                    <!-- Plan içeriği -->
                                    <div class="w-100 card-body d-flex flex-column d-flex flex-column-fluid border rounded-top-3 bg-light py-15 px-10">
                                        <div class="mb-7 text-center">
                                            <h3 class="text-gray-900 fw-bolder">
                                                {{ $t('licences.' + item.package_name) }}
                                            </h3>
                                            <div class="text-gray-600 fw-semibold mh-100px scroll-y">
                                                {{item.description}}
                                            </div>

                                            <!-- ✅ DÜZELTME: Tek fiyat gösterim konteyneri -->
                                            <div class="price-info-container mt-4">
                                                <!-- Ana fiyat gösterimi -->
                                                <div class="price-main text-center">
                                                    <span class="fs-3x fw-bold text-primary price-display">
                                                        {{ getDisplayPrice(item, activePriceView) }}
                                                    </span>
                                                    <span class="mb-2 text-primary ms-2">{{ userData.currency_code }}</span>
                                                    <span class="fs-7 fw-semibold opacity-50">/
                                                        <span v-if="activePriceView == 'monthly'"> {{ $t('month') }} </span>
                                                        <span v-if="activePriceView == 'annual'"> {{ $t('year') }} </span>
                                                    </span>
                                                </div>
                                                
                                                <!-- Faturalama bilgisi -->
                                                <div class="text-center mt-2">
                                                    <div class="fs-7 text-gray-600" v-if="activePriceView == 'monthly'">
                                                        {{ $t('billed_monthly') }} 
                                                    </div>
                                                    <div class="fs-7 text-gray-600" v-else>
                                                        {{ $t('billed_annually') }} 
                                                    </div>
                                                </div>

                                                <!-- Tasarruf gösterimi (sadece yıllık için) -->
                                                <div class="text-center mt-2" v-if="activePriceView == 'annual' && calculateSavings(item) > 0">
                                                    <div class="fs-7 text-success">
                                                        <i class="bi bi-check-circle text-success me-1"></i> 
                                                        {{ $t('save_amount', [calculateSavings(item), userData.currency_code]) }}
                                                    </div>
                                                </div>

                                                <!-- Fiyat türü etiketi ve açıklama -->
                                                <div class="price-label mt-3" v-if="shouldShowPriceInfo(item)">
                                                    <small class="badge" :class="{
                                                        'badge-light-success': userData.package_type === 0,
                                                        'badge-light-warning': userData.period_end <= 0,
                                                        'badge-light-info': item.package_type > userData.package_type
                                                    }">
                                                        <i class="bi me-1" :class="{
                                                            'bi-star': userData.package_type === 0,
                                                            'bi-arrow-clockwise': userData.period_end <= 0,
                                                            'bi-arrow-up': item.package_type > userData.package_type
                                                        }"></i>
                                                        {{ getPriceInfoText(item) }}
                                                    </small>
                                                    
                                                    <!-- Açıklama metni -->
                                                    <div class="fs-7 text-muted mt-1">
                                                        <span v-if="userData.package_type === 0">
                                                            {{ $t('trial_to_full_conversion_description') }}
                                                        </span>
                                                        <span v-else-if="userData.period_end <= 0">
                                                            {{ $t('expired_renewal_price_description') }}
                                                        </span>
                                                        <span v-else-if="item.package_type > userData.package_type">
                                                            {{ $t('upgrade_difference_price_description') }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <!-- Tooltip -->
                                                <div class="price-tooltip position-absolute top-0 end-0 mt-2 me-2" 
                                                    v-if="shouldShowPriceInfo(item)"
                                                    data-bs-toggle="tooltip" data-bs-trigger="hover"
                                                    :data-bs-title="getPriceTooltipText(item)"
                                                    :title="getPriceTooltipText(item)">
                                                    <i class="bi bi-info-circle text-muted cursor-help"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Plan özellikleri -->
                                        <div class="w-100 mb-10">
                                            <div class="d-flex align-items-center mb-1">
                                                <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">
                                                    <span v-html="$t('max_active_users_count', { count: item.user_count })"></span>
                                                </span>
                                                <i class="bi bi-person-check-fill fs-3"></i>
                                            </div>
                                            
                                            <div class="d-flex align-items-center">
                                                <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3" v-if="activePriceView == 'monthly'">
                                                    {{ $t('only_credit_card') }}                                                     
                                                </span>
                                                <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3" v-if="activePriceView == 'annual'"> 
                                                    {{ $t('credit_card_bank_transfer') }}  
                                                </span>
                                                <i class="bi bi-credit-card-fill fs-3"></i>
                                            </div>
                                            
                                            <div class="separator my-5 border-gray-300"></div>
                                            
                                            <!-- Modül listesi -->
                                            <div class="d-flex flex-column content-justify-center flex-grow-1" v-for="moduleItem in getModuleTitles(item.package_type)" :key="moduleItem.id">
                                                <div class="d-flex fs-5 fw-semibold align-items-center border-bottom border-1 border-gray-300 my-3">
                                                    {{ $t('licences.' + moduleItem.key_value) }}
                                                </div>
                                                <div class="d-flex fs-6 align-items-center my-1" v-for="subItem in moduleItem.items" :key="subItem.id">
                                                    <span class="fs-6 text-gray-800 flex-grow-1 pe-3">
                                                        <div class="d-flex flex-column">
                                                            {{ $t('licences.' + subItem.key_value) }}
                                                            
                                                            <span v-if="subItem.id == 17 && item.is_company_inquiry_active == 1" class="fs-7 text-gray-600">
                                                                <small class="text-muted" v-html="$t('request_count_per_period', { 
                                                                    request: item.company_inquiry_rate_limit, 
                                                                    period: item.company_inquiry_exceed_period + ' ' + getPeriodTypeName(item.company_inquiry_period_type) 
                                                                })"></small>
                                                            </span>
                                                            <span v-if="subItem.id == 18 && item.is_address_inquiry_active == 1" class="fs-7 text-gray-600">
                                                                <small class="text-muted" v-html="$t('request_count_per_period', { 
                                                                    request: item.address_inquiry_rate_limit, 
                                                                    period: item.address_inquiry_exceed_period + ' ' + getPeriodTypeName(item.address_inquiry_period_type) 
                                                                })"></small>
                                                            </span>
                                                        </div>
                                                    </span>
                                                    <i class="bi bi-check-circle fs-3" :class="{'text-primary': subItem.licence_requirement > 2, 'text-success':  subItem.licence_requirement <= 2}"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Plan seçim butonu -->
                                    <div class="card-footer border-top-0 col-lg-12 p-3 bg-light">
                                        <div class="d-grid gap-2"> 
                                            <button type="button" class="btn btn-sm btn-primary" 
                                                :class="{'btn-info': item.package_type == userData.package_type, 'btn-success': selectedLicence && selectedLicence.id === item.id}" 
                                                @click="selectPlan(item)">
                                                
                                                <span v-if="selectedLicence && selectedLicence.id === item.id">
                                                    {{ $t('selected')}}
                                                </span>
                                                <span v-else>
                                                    <span v-if="item.package_type == userData.package_type">
                                                        {{ $t('extend_your_plan')}}
                                                    </span>
                                                    <span v-else>
                                                        {{ $t('select_plan')}}
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Kullanıcı ekleme formu -->
                        <div class="row" v-if="activeView == 'addUser'">
                            <div class="card card-dashed shadow-sm">
                                <div class="card-body">
                                    <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                                        <i class="bi bi-info-circle fs-2tx text-primary me-4"></i>
                                        <div class="d-flex flex-stack flex-grow-1">
                                            <div class="fw-semibold">
                                                <div class="fs-6 text-gray-700">
                                                    <span v-html="$t('active_users_count', { count: userData.user_count })"></span>
                                                    {{ $t('if_you_want_to') }} 
                                                    <br>
                                                     {{ $t('the_price_for_users') }} 
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body ps-15">
                                        <div class="table-responsive">
                                            <table class="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                                <thead>
                                                    <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-175px"> {{ $t('product') }} </th>
                                                        <th class="min-w-100px text-end"> {{ $t('unit_price') }} </th>
                                                        <th class="min-w-70px text-center"> {{ $t('qty') }} </th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr>
                                                        <td>
                                                            <div class="d-flex align-items-center">
                                                                <a href="#" class="symbol symbol-50px">
                                                                    <span class="symbol-label theme-light-show" style="background-image:url('/assets/theme/media/svg/avatars/blank.svg');"></span>
                                                                    <span class="symbol-label theme-dark-show" style="background-image:url('/assets/theme/media/svg/avatars/blank-dark.svg');"></span>
                                                                </a>
                                                                <div class="ms-5">
                                                                    <a href="#" class="fw-bold text-gray-600 text-hover-primary"> {{ $t('user') }} </a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-end">
                                                            {{userData.user_price}} {{userData.currency_code}}
                                                            <div v-if="activePriceView == 'monthly'">
                                                                <small>{{$t('monthly')}}</small>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="d-flex align-items-center justify-content-center mt-3 user-counter">
                                                                <button type="button" class="btn btn-icon btn-sm btn-light btn-icon-gray-400" 
                                                                    :disabled="upgradeForm.user_count <= 0" @click="changeUserCount(-1)">
                                                                    <i class="bi bi-dash fs-3x"></i>
                                                                </button>
                                                                <input type="number" class="form-control form-control-sm text-center mx-2 px-2 fs-3 fw-bold text-gray-800" 
                                                                    v-model.number="upgradeForm.user_count" @input="calculateUserTotal" min="0" />
                                                                <button type="button" class="btn btn-icon btn-sm btn-light btn-icon-gray-400" 
                                                                    @click="changeUserCount(1)">
                                                                    <i class="bi bi-plus fs-3x"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" class="fs-3 text-gray-900 text-end">
                                                             {{ $t('grand_total') }} 
                                                        </td>
                                                        <td class="text-gray-900 fs-3 fw-bolder text-center">
                                                            {{upgradeForm.user_total}} {{userData.currency_code}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. Adım: Plan detayları -->
                    <div class="row" v-if="activeStep == 2">
                        <div class="row mb-10 mb-xl-0">
                            <h1 class="fw-bold text-gray-800 mb-5"> {{ $t('plan_details') }} </h1>
                            <div class="col-lg-12 pb-5">
                                <div class="table-responsive">
                                    <table class="table mb-3">
                                        <thead>
                                            <tr class="border-bottom fs-6 fw-bold text-muted">
                                                <th class="min-w-175px pb-2"> {{ $t('description') }} </th>
                                                <th class="min-w-70px text-end pb-2"> {{ $t('plan_type') }} </th>
                                                <th class="min-w-80px text-end pb-2"> {{ $t('total_price') }} </th>
                                                <th class="min-w-100px text-end pb-2"> {{ $t('vat') }} 
                                                    <span v-if="getVatInfo().is_add_vat == 1">({{getVatInfo().vat_rate}}%)</span>
                                                    <span v-if="getVatInfo().is_add_vat == 0"> {{ $t('none') }} </span>
                                                </th>
                                                <th class="min-w-100px text-end pb-2"> {{ $t('total') }} </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="fw-bold text-gray-700 fs-5">
                                                <td class="d-flex align-items-center pt-6">                                            
                                                    <i class="bi bi-diamond-fill fs-10 me-2 text-success"></i>
                                                    <span v-if="activeView == 'upgradePlan'">
                                                        {{$t('licences.' + selectedLicence.package_name)}}
                                                        <!-- <span v-if="activePriceView == 'monthly'"> 
                                                            ({{getDisplayPrice(selectedLicence, 'monthly')}} {{userData.currency_code}} x {{getPaymentPeriod()}} installments)
                                                        </span> -->
                                                    </span>
                                                    <span v-if="activeView == 'addUser'">
                                                        {{ $t('user') }} x {{upgradeForm.user_count}}
                                                        <!-- <span v-if="activePriceView == 'monthly'"> 
                                                            ({{userData.user_price}} {{userData.currency_code}} x {{getPaymentPeriod()}} installments)
                                                        </span> -->
                                                    </span>
                                                </td>
                                                <td class="pt-6 text-end">
                                                    {{activePriceView == 'monthly' ? $t('monthly') : (getPeriodDays() + ' ' + $t('days'))}}
                                                </td>
                                                <td class="pt-6 text-end">{{totals.sub_total}}</td>
                                                <td class="pt-6 text-end">{{totals.vat_amount}}</td>
                                                <td class="pt-6 text-end text-gray-800 fw-bolder">{{totals.grand_total}}</td>
                                            </tr>
                                            <tr class="pt-6 border-top border-gray-300">
                                                <td class="pt-6 text-end fw-bold text-gray-600 fs-6" colspan="4"> {{ $t('subtotal') }} </td>
                                                <td class="pt-6 text-end fw-bold fs-6 text-gray-800">{{totals.sub_total}} {{userData.currency_code}}</td>
                                            </tr>
                                            <tr>
                                                <td class="pt-3 text-end fw-bold text-gray-600 fs-6" colspan="4"> {{ $t('vat') }}                                                     
                                                    <span v-if="getVatInfo().is_add_vat == 1">({{getVatInfo().vat_rate}}%)</span>
                                                    <span v-if="getVatInfo().is_add_vat == 0"> {{ $t('none') }} </span>
                                                </td>
                                                <td class="pt-3 text-end fw-bold fs-6 text-gray-800" v-if="getVatInfo().is_add_vat == 1">{{totals.vat_amount}} {{userData.currency_code}}</td>
                                                <td class="pt-3 text-end fw-bold fs-6 text-gray-800" v-if="getVatInfo().is_add_vat == 0"> {{ $t('none') }} </td>
                                            </tr>
                                            <tr>
                                                <td class="pt-3 text-end fw-bold fs-3 text-gray-800" colspan="4"> {{ $t('grand_total') }} </td>
                                                <td class="pt-3 text-end fw-bolder fs-3 text-gray-800">{{totals.grand_total}} {{userData.currency_code}}</td>
                                            </tr>
                                            <!-- <tr v-if="activePriceView == 'monthly'">
                                                <td class="pt-3 text-end fw-bold fs-3 text-gray-800" colspan="4"> {{ $t('monthly_price') }} </td>
                                                <td class="pt-3 text-end fs-3">
                                                    <div class="fw-bolder text-gray-800">{{totals.monthly_price_total}} {{userData.currency_code}} </div>
                                                    <div class="fw-bolder fs-7"> (Paid in {{getPaymentPeriod()}} installments) </div>
                                                </td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <!-- Ödeme yöntemi seçimi -->
                        <div class="d-flex justify-content-between flex-column flex-md-row">
                            <div class="flex-grow-1 mt-10">
                                <h1 class="fw-bold text-gray-800 mb-5"> {{ $t('payment_method') }} </h1>
                                <div class="d-flex flex-column">
                                    <div class="row">
                                        <div class="col-lg-6" :class="{'col-lg-12': activePriceView == 'monthly'}">
                                            <label class="btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-3"
                                                :class="{'active btn-active-light-primary': upgradeForm.payment_method == 1}">
                                                <div class="d-flex align-items-center me-2">
                                                    <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                                                        <input class="form-check-input" v-model="upgradeForm.payment_method" type="radio" name="payment_plan" value="1">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h2 class="d-flex align-items-center fs-3 fw-bold flex-wrap text-uppercase">
                                                            {{ $t('credit_card') }} 
                                                        </h2>
                                                        <div class="fw-semibold opacity-75">
                                                            {{ $t('payment_credit_card') }} 
                                                            <!-- <div class="mt-3 fs-7 text-gray-700" v-if="activePriceView == 'monthly'">
                                                                {{ $t('by_choosing_the_annual_payment_plan_you_can_make') }}
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="ms-5">
                                                    <i class="bi bi-credit-card fs-3x"></i>
                                                </div>
                                            </label>
                                        </div>
                                        <div class="col-lg-6" v-if="activePriceView == 'annual'">
                                            <label class="btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-3"
                                                :class="{'active btn-active-light-info': upgradeForm.payment_method == 2}">
                                                <div class="d-flex align-items-center me-2">
                                                    <div class="form-check form-check-custom form-check-solid form-check-info me-6">
                                                        <input class="form-check-input" v-model="upgradeForm.payment_method" type="radio" name="payment_plan" value="2">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h2 class="d-flex align-items-center fs-3 fw-bold flex-wrap text-uppercase">
                                                             {{ $t('bank_transfer') }} 
                                                        </h2>
                                                        <div class="fw-semibold opacity-75">
                                                             {{ $t('in_the_next_step') }} 
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="ms-5">
                                                    <i class="bi bi-cash-stack fs-3x"></i>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 3. Adım: Fatura adresi -->
                    <div class="row" v-if="activeStep == 3">
                        <div class="row mb-10 mb-xl-0" v-if="!isEditBillingAddress">
                            <h1 class="fw-bold text-gray-800 mb-5"> {{ $t('billing_address') }} </h1>
                            <div class="col-lg-12">
                                <div class="card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6">
                                    <div class="d-flex flex-column py-2">
                                        <div class="d-flex align-items-center fs-5 fw-bold mb-5">
                                            {{companyInfo.company_name}}
                                            <span class="badge badge-light-success fs-7 ms-2"> {{ $t('primary') }} </span>
                                        </div>
                                        <div class="fs-6 fw-semibold text-gray-600">
                                            {{companyInfo.company_address}}
                                        </div>
                                        <div class="fs-6 fw-semibold text-gray-600">
                                            {{companyInfo.company_city}}
                                        </div>
                                        <div class="fs-6 fw-semibold text-gray-600">
                                            {{companyInfo.company_country_code}}
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center py-2">
                                        <button class="btn btn-sm btn-light btn-active-light-primary" @click="onEditBillingAddress()"> {{ $t('edit') }} </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Fatura adresi düzenleme formu -->
                        <div class="fv-row row rounded shadow-sm p-5" v-if="isEditBillingAddress">
                            <h1 class="fw-bold text-gray-800 mb-5"> {{ $t('edit_billing_address') }} </h1>
                            
                            <!-- GetAddress component -->
                            <GetAddress @address-selected="onSelectAddress" v-if="userData.is_address_inquiry_active == 1 && userData.address_inquiry_sub_type == 2"/>
                            
                            <div class="col-lg-4">
                                <div class="fv-row">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        {{ $t('post_code') }}
                                    </label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="billingForm.company_postcode">
                                        <button v-if="userData.is_address_inquiry_active == 1 && userData.address_inquiry_sub_type == 1" type="button" 
                                            class="input-group-text m-0 cursor-pointer text-hover-info" 
                                            @click="onFindAddressByPostCode()" 
                                            data-bs-toggle="modal" 
                                            data-bs-target="#kt_modal_search_address" 
                                            data-kt-menu-trigger="click" 
                                            data-kt-menu-placement="bottom-end"
                                            :disabled="!billingForm.company_postcode">
                                            <i class="fas fa-search fs-4 me-3"></i> {{ $t('search_by_post_code') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="fv-row">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        {{ $t('city') }}
                                    </label>
                                    <input type="text" class="form-control" v-model="billingForm.company_city">
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="fv-row">
                                    <label class="fs-6 fw-bold form-label mt-3">{{ $t('district') }}                                                    
                                    </label>
                                    <input type="text" class="form-control" v-model="billingForm.company_district">
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="fv-row">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        {{ $t('address') }}
                                    </label>
                                    <textarea class="form-control" v-model="billingForm.company_address"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-4 mb-3">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    {{ $t('primary_person') }}
                                </label>
                                <input type="text" class="form-control" v-model="billingForm.primary_person"> 
                            </div>
                            <div class="col-lg-4 mb-3">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    {{ $t('mobile_phone') }}
                                </label>
                                <div class="input-group">
                                    <span class="input-group-text fs-7 text-primary" v-if="billingForm.company_country_code !== '-1'">
                                        {{billingForm.company_country_code}} {{billingForm.phone_country_code}}
                                    </span>
                                    <input type="text" class="form-control" v-model="billingForm.company_gsm"> 
                                </div>
                            </div>
                            <div class="col-lg-4 mb-3">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    {{ $t('email') }}
                                </label>
                                <input type="email" class="form-control" v-model="billingForm.company_email" 
                                    :class="{'border border-danger': !isValidEmail && billingForm.company_email}"> 
                                <small class="text-danger" v-if="!isValidEmail && billingForm.company_email">
                                    {{ $t('email_is_not_valid') }}
                                </small>
                            </div>  
                            <div class="d-flex align-items-center justify-content-end text-end py-2">
                                <button type="reset" class="btn btn-light me-3" @click="cancelEditBillingAddress"> 
                                    {{ $t('cancel') }} 
                                </button>
                                <button class="btn btn-sm btn-primary" @click="saveBillingAddress()" 
                                    :disabled="!isValidEmail && billingForm.company_email"> 
                                    {{ $t('update') }} 
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- 4. Adım: Ödeme onayı -->
                    <div class="row" v-if="activeStep == 4">
                        <!-- Kredi kartı ödeme -->
                        <div class="card card-flush" v-if="upgradeForm.payment_method == 1">
                            <div class="card-body text-center">
                                <div class="fw-bolder fs-2x text-gray-900 mb-4">                                    
                                    <div class="mb-2">
                                        <span class="text-gray-800 fw-bold me-1" v-if="activePriceView == 'monthly' && userData.package_type < 2">
                                            <span class="me-3"> {{ $t('grand_total') }} </span>
                                            <b>{{totals.monthly_price_total}} {{userData.currency_code}}</b>
                                        </span> 
                                        <span class="text-gray-800 fw-bold me-1" v-else>
                                            <span class="me-3"> {{ $t('grand_total') }} </span>
                                            <b> + {{totals.grand_total}} {{userData.currency_code}}</b>
                                        </span> 
                                        <small class="text-gray-600 fw-semibold" v-if="activePriceView == 'monthly'"> 
                                            {{ $t('per_month') }} 
                                        </small>
                                    </div>
                                    <div class="fs-3 text-gray-800 fw-semibold">
                                        <span v-if="activeView == 'upgradePlan'">
                                            {{$t('licences.' + selectedLicence.package_name)}}
                                        </span>
                                        <span v-if="upgradeForm.user_count > 0"> + {{upgradeForm.user_count}} {{ $t('user') }} </span>
                                    </div>
                                </div>
                                <div class="fw-semibold fs-6 text-gray-500 mb-7">
                                     {{ $t('we_have_received_your_upgrade_request') }} 

                                    <div class="alert bg-light-info d-flex flex-column flex-sm-row w-100 p-5 mt-5" v-if="userData.package_type >= 2">
                                        <i class="bi bi-info-circle fs-2hx text-info me-4 mb-5 mb-sm-0"></i>
                                        <div class="d-flex flex-column pe-0 pe-sm-10 align-items-start ">
                                            <h4 class="fw-semibold">{{ $t('plan_update_title') }}</h4>
                                            <span> {{ $t('plan_update_intro') }} </span>
                                            <span> {{ $t('plan_update_reason') }} </span>
                                            <span >
                                                <strong>{{ $t('plan_update_summary') }}</strong> {{ $t('plan_update_billing_note') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <img src="assets/theme/media/illustrations/sigma-1/1.png" class="mw-100 mh-300px theme-light-show" alt="">
                                    <img src="assets/theme/media/illustrations/sigma-1/1-dark.png" class="mw-100 mh-300px theme-dark-show" alt="">
                                </div> 
                            </div>
                        </div>      

                        <!-- Havale ödeme -->
                        <div v-if="upgradeForm.payment_method == 2">
                            <div class="card card-dashed bg-light-primary border-primary flex-row flex-stack flex-wrap p-5">
                                <div class="d-flex align-items-sm-center">
                                    <div class="symbol symbol-50px me-5">
                                        <span class="symbol-label bg-light">
                                            <i class="bi bi-cash-stack fs-3x text-primary"></i>
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                        <div class="me-20">
                                            <span class="text-gray-800 fs-6 fw-bold"> {{ $t('this_is_your_reference') }} </span>
                                            <div class="input-group input-group-sm mt-1">
                                                <input type="text" class="form-control form-control-sm form-control-solid border border-gray-300" 
                                                    style="font-size: 15px !important; font-weight: bolder;" 
                                                    ref="referenceNumber" readonly v-model="licenceReferenceNumber">
                                                <button class="btn btn-sm btn-secondary" :class="{'btn-success': isCopied}" @click="copyToClipboard()">
                                                    <b v-if="!isCopied"> {{ $t('copy') }} </b>
                                                    <b v-if="isCopied"> {{ $t('copied') }} </b>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 ms-20">
                                            <div class="text-gray-800 fw-bolder d-block fs-3">
                                                <span class="fs-5 me-3"> {{ $t('grand_total') }}  </span>
                                                <span class="fs-2" v-if="activePriceView == 'monthly'">{{totals.monthly_price_total}} {{userData.currency_code}}</span>
                                                <span class="fs-2" v-else>{{totals.grand_total}} {{userData.currency_code}}</span>
                                            </div>
                                            <div class="fs-6 text-gray-600 fw-semibold">
                                                <span v-if="activeView == 'upgradePlan'">
                                                    {{$t('licences.' + selectedLicence.package_name)}}
                                                </span>
                                                <span v-if="upgradeForm.user_count > 0"> + {{upgradeForm.user_count}} {{ $t('user') }} </span>
                                            </div>
                                            <div class="fw-semibold d-block fs-7"> {{ $t('when_making_a_payment') }} </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Banka bilgileri -->
                            <div class="my-10" v-if="bankDescription" v-html="bankDescription"></div>

                            <div class="card card-flush">
                                <div class="card-body text-center pb-0">
                                    <div class="fs-6 text-gray-800 mb-5">
                                         {{ $t('we_have_received_your_licence_request') }} 
                                    </div>
                                    <div class="mb-3">
                                        <img src="assets/theme/media/illustrations/sigma-1/1.png" class="mw-100 mh-200px theme-light-show" alt="">
                                        <img src="assets/theme/media/illustrations/sigma-1/1-dark.png" class="mw-100 mh-200px theme-dark-show" alt="">
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 5. Adım: Teşekkür sayfası -->
                    <div class="row" v-if="activeStep == 5">
                        <div class="card card-flush">
                            <div class="card-body text-center">
                                <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
                                     {{ $t('thank_you') }} 
                                </h1>
                                <div class="text-gray-600 fw-semibold fs-5 mb-3">
                                    {{ $t('upgrade_completed_successfully') }}
                                </div>
                                <div class="mb-3">
                                    <img src="assets/theme/media/illustrations/sigma-1/2.png" class="mw-100 mh-300px theme-light-show" alt="">
                                    <img src="assets/theme/media/illustrations/sigma-1/2-dark.png" class="mw-100 mh-300px theme-dark-show" alt="">
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Alt butonlar -->
                <div class="card-footer py-3" v-if="activeStep !== 5 && activeStep > 0">
                    <!-- Geri butonu -->
                    <button v-if="activeStep > 0 && activeStep !== 4" type="button" class="btn btn-lg btn-light me-3" @click="goBackStep()">
                        {{ $t('back') }} 
                    </button>

                    <!-- Devam butonu -->
                    <button v-if="canShowContinueButton" type="button" class="btn btn-lg btn-primary float-end" 
                        @click="continueToNext()" :disabled="!canContinue">
                        <span class="indicator-label" v-if="!isProcessing">
                             {{ $t('continue') }} 
                        </span>
                        <span class="indicator-progress" v-if="isProcessing">
                             {{ $t('please_wait') }}     
                             <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                    
                    <!-- Onay ve devam butonu -->
                    <button v-if="activeStep == 3 && !isEditBillingAddress && userData.package_type < 2" type="button" 
                        class="btn btn-lg btn-success float-end" @click="startTransaction()" :disabled="isProcessing">
                        <span v-if="!isProcessing">  {{ $t('confirm_and_continue') }}  </span>
                        <span class="indicator-progress" v-if="isProcessing">
                             {{ $t('please_wait') }}     
                             <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                    <!-- Mevcut paketi yükseltme için onay ve devam butonu -->
                    <button v-if="activeStep == 3 && !isEditBillingAddress && userData.package_type >= 2" type="button" 
                        class="btn btn-lg btn-success float-end" @click="continueToNext()" :disabled="isProcessing">
                        <span v-if="!isProcessing">  {{ $t('confirm_and_continue') }}  </span>
                        <span class="indicator-progress" v-if="isProcessing">
                             {{ $t('please_wait') }}     
                             <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>

                    <!-- Ödeme adımı butonları -->
                    <div class="row w-100" v-if="activeStep == 4 && userData.package_type < 2">
                        <div class="col-lg-6">
                            <button type="button" class="btn btn-lg btn-danger me-3" @click="cancelTransaction()">
                                 {{ $t('cancel_request') }} 
                            </button>
                        </div>
                        <div class="col-lg-6">
                            <!-- Kredi kartı ödeme butonları -->
                            <!-- Tek seferlik ödeme -->
                            <stripe-checkout
                                ref="checkoutRef"
                                mode="payment"
                                :pk="stripeData.strpk"
                                :session-id="stripeData.strsid"
                                @loading="v => isProcessing = v"
                                v-if="activePriceView !== 'monthly' && stripeData.strsid && upgradeForm.payment_method == 1">
                                <button @click="processPayment" 
                                    class="btn btn-lg btn-success float-end" type="button" :disabled="isProcessing">
                                    <span v-if="!isProcessing"> {{ $t('confirm_and_proceed_to') }} </span>
                                    <span class="indicator-progress" v-if="isProcessing">
                                         {{ $t('please_wait') }}     
                                         <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </stripe-checkout>

                            <!-- Aylık ödeme (abonelik) -->
                            <stripe-checkout
                                ref="checkoutRef"
                                mode="subscription"
                                :pk="stripeData.strpk"
                                :session-id="stripeData.strsid"
                                @loading="v => isProcessing = v"
                                v-if="activePriceView === 'monthly' && stripeData.strsid && upgradeForm.payment_method == 1">
                                <button @click="processPayment" 
                                    class="btn btn-lg btn-success float-end" type="button" :disabled="isProcessing">
                                    <span v-if="!isProcessing"> {{ $t('confirm_and_proceed_to') }} </span>
                                    <span class="indicator-progress" v-if="isProcessing">
                                         {{ $t('please_wait') }}     
                                         <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </stripe-checkout>

                            <!-- Fallback buton (Stripe data yoksa) -->
                            <button v-if="upgradeForm.payment_method == 1 && !stripeData.strsid" 
                                @click="processPayment" 
                                class="btn btn-lg btn-success float-end" type="button" :disabled="isProcessing">
                                <span v-if="!isProcessing"> {{ $t('confirm_and_proceed_to') }} </span>
                                <span class="indicator-progress" v-if="isProcessing">
                                     {{ $t('please_wait') }}     
                                     <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>

                            <!-- Havale ödeme butonu -->
                            <button v-if="upgradeForm.payment_method == 2" type="button" 
                                class="btn btn-lg btn-success float-end" @click="completeTransaction()" :disabled="isProcessing">
                                <span class="indicator-label" v-if="!isProcessing">
                                     {{ $t('complete_and_close') }} 
                                </span>
                                <span class="indicator-progress" v-if="isProcessing">
                                     {{ $t('please_wait') }}     
                                     <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="row w-100" v-if="activeStep == 4 && userData.package_type >= 2">
                        <div class="col-lg-12">
                            <button type="button" class="btn btn-lg btn-light me-3" @click="goBackStep()">
                                {{ $t('back') }} 
                            </button>
                            <button type="button" 
                                class="btn btn-lg btn-success float-end" @click="updateSubscriptionPrice()" :disabled="isProcessing">
                                <span class="indicator-label" v-if="!isProcessing">
                                     {{ $t('complete_and_close') }} 
                                </span>
                                <span class="indicator-progress" v-if="isProcessing">
                                     {{ $t('please_wait') }}     
                                     <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false});
import { StripeCheckout } from '@james090500/vue-stripe';
export default {
  name: "Upgrade",
  components: { StripeCheckout },  
  data() {
    return {
        userData: this.$getUser(),
        activeStep: 0,
        activeView: null,
        licenceList: [],
        modules: [],
        selectedLicence: null,
        activePriceView: 'monthly',
        isProcessing: false,
        upgradeForm: {
            licence_id: null,
            user_count: 0,
            user_total: 0,
            payment_method: 1,
            subtotal: 0
        },
        totals: {
            sub_total: 0.00,
            vat_amount: 0.00,
            grand_total: 0.00,
            monthly_price_total: 0.00
        },
        companyInfo: {},
        billingForm: {
            primary_person: null,
            company_country_code: '-1',
            phone_country_code: null,
            company_gsm: null,
            company_email: null,
            company_postcode: null,
            company_address: null,
            company_city: null,
            company_district: null
        },
        isEditBillingAddress: false,
        isViewLicenceGuid: false,
        licenceReferenceNumber: null,
        licenceTransactionId: null,
        isCopied: false,
        bankDescription: null,
        periodTypeList: [
            { id: 1, text: this.$t('minute') },
            { id: 2, text: this.$t('hour') },
            { id: 3, text: this.$t('day') },
            { id: 4, text: this.$t('week') },
            { id: 5, text: this.$t('month') },
            { id: 6, text: this.$t('year') },
        ],
        stripeData: {
            strpk: this.$getUser().stripe ? this.$getUser().stripe.strpk : null,
            strsid: null
        }
    };
  },
  computed: {
    // Kalan süre uyarısı gösterilmeli mi?
    shouldShowRemainingTimeWarning() {
        return this.userData.payment_type == 2 &&
               this.userData.package_type > 0 && 
               this.activeView == 'upgradePlan' && 
               (this.activeStep == 1 || this.activeStep == 2) && 
               (this.userData.period_end > 0 && this.userData.period_end <= 30);
    },

    // Devam butonu aktif mi?
    canContinue() {
        if (this.activeStep == 1 && this.activeView == 'upgradePlan') {
            return this.selectedLicence !== null;
        }
        if (this.activeStep == 1 && this.activeView == 'addUser') {
            return this.upgradeForm.user_count > 0;
        }
        if (this.activeStep == 2) {
            return this.upgradeForm.payment_method > 0;
        }
        return true;
    },

    // Devam butonu gösterilmeli mi?
    canShowContinueButton() {
        return (this.activeStep == 1) || (this.activeStep == 2);
    },
    // Email validasyonu
    isValidEmail() {
        if (!this.billingForm.company_email) return true;
        return /^[^@]+@\w+(\.\w+)+\w$/.test(this.billingForm.company_email);
    },

    // Modül başlıklarını getir (cache'li)
    getModuleTitles() {
        let cachedResults = new Map();
        let lastModulesVersion = null;
        
        return (packageType) => {
            const currentModulesVersion = JSON.stringify(this.modules);
            if (lastModulesVersion !== currentModulesVersion) {
                cachedResults.clear();
                lastModulesVersion = currentModulesVersion;
            }
            
            if (cachedResults.has(packageType)) {
                return cachedResults.get(packageType);
            }

            const childModulesMap = new Map();
            
            this.modules.forEach(module => {
                if (module.parent_id && module.licence_requirement <= packageType) {
                    if (!childModulesMap.has(module.parent_id)) {
                        childModulesMap.set(module.parent_id, []);
                    }
                    childModulesMap.get(module.parent_id).push(module);
                }
            });
            
            const result = this.modules
                .filter(module => module.type === 1 && module.licence_requirement <= packageType)
                .map(module => ({
                    ...module,
                    items: childModulesMap.get(module.id) || []
                }));
                
            cachedResults.set(packageType, result);
            return result;
        };
    },

    // Periyot tipi adını getir
    getPeriodTypeName() {
        return (value) => {
            if (value && this.periodTypeList) {
                const period = this.periodTypeList.find(p => p.id == value);
                return period ? period.text : '';
            }
            return '';
        } 
    }
  },

  methods: {
    // Veriyi yükle
    async getData() {
        try {
            const user = this.$getUser();
            if (!user || !user.session_id) {
                console.warn('Session expired during data fetch');
                this.$emit('close-modal');
                return;
            }
            
            const parameters = {
                session_id: user.session_id
            };
            
            const response = await axios.post('/api/Lic/Get', parameters, {'Content-Type': 'application/json'});
            
            if (!response.data.error) {
                this.licenceList = response.data.packages;
                this.modules = response.data.modules;
                this.checkHelpPageView();
            } else {
                console.error('API Error:', response.data.error);
            }
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                console.warn('Authentication error, closing modal');
                this.$emit('close-modal');
            }
        }
    },

    // Plan seç
    selectPlan(plan) {
        this.selectedLicence = plan;
        this.upgradeForm.licence_id = plan.id;
        
        if (this.activeView == 'addUser') {
            this.upgradeForm.user_count = 1;
            this.calculateUserTotal();
        }
        
        this.calculateGrandTotal();
    },

    // Kullanıcı sayısını değiştir
    changeUserCount(delta) {
        const newCount = this.upgradeForm.user_count + delta;
        if (newCount >= 0) {
            this.upgradeForm.user_count = newCount;
            this.calculateUserTotal();
        }
    },

    // Kullanıcı toplamını hesapla
    calculateUserTotal() {
        const userPrice = parseFloat(this.userData.user_price) || 0;
        this.upgradeForm.user_total = (userPrice * this.upgradeForm.user_count).toFixed(2);
        this.upgradeForm.subtotal = this.upgradeForm.user_total;
        this.calculateGrandTotal();
    },

    // Görüntülenecek fiyatı getir
    getDisplayPrice(item, type) {
        if (type === 'monthly') {
            const price = this.shouldUseDifferencePrice(item) ? 
                parseFloat(item.calculated_price_monthly || 0) : 
                parseFloat(item.total_calculated_price_monthly || 0);
            
            return price.toFixed(2);
        } else {
            // Yıllık fiyat
            const price = this.shouldUseDifferencePrice(item) ? 
                parseFloat(item.calculated_price || 0) : 
                parseFloat(item.total_calculated_price || 0);
            
            return price.toFixed(2);
        }
    },

    // Fark fiyatı kullanılmalı mı?
    shouldUseDifferencePrice(item) {
        const userPackageType = this.userData.package_type || 0;
        const userPeriodEnd = this.userData.period_end || 0;
        
        // Deneme sürümü veya süresi dolmuş -> calculated_price kullan (temel fiyat)
        if (userPackageType === 0 || userPeriodEnd <= 0) {
            return true; // calculated_price = temel fiyat
        }
        
        // 30 günden az kalmış -> total_calculated_price kullan (tam fiyat)
        if (userPeriodEnd < 30) {
            return false; // total_calculated_price = tam fiyat
        }
        
        // Upgrade durumu -> calculated_price kullan (fark fiyatı)
        if (item.package_type > userPackageType && userPeriodEnd >= 30) {
            return true; // calculated_price = fark fiyatı
        }
        
        // Diğer durumlar -> total_calculated_price kullan (tam fiyat)
        return false;
    },

    // Tasarrufu hesapla
    calculateSavings(item) {
        const monthlyPrice = this.shouldUseDifferencePrice(item) ? 
            parseFloat(item.calculated_price_monthly || 0) : 
            parseFloat(item.total_calculated_price_monthly || 0);
        
        const annualPrice = this.shouldUseDifferencePrice(item) ? 
            parseFloat(item.calculated_price || 0) : 
            parseFloat(item.total_calculated_price || 0);
        
        // 12 aylık ödeme toplamı
        const monthlyTotal = monthlyPrice * 12;
        
        // Tasarruf = (12 aylık toplam) - (yıllık fiyat)
        const savings = Math.max(0, monthlyTotal - annualPrice);
        
        return savings.toFixed(2);
    },

    // Fiyat bilgisi gösterilmeli mi?
    shouldShowPriceInfo(item) {
        const userPackageType = this.userData.package_type || 0;
        const userPeriodEnd = this.userData.period_end || 0;
        
        // Deneme sürümünde bilgi göster
        if (userPackageType === 0) {
            return true;
        }
        
        // Süresi dolmuşsa bilgi göster
        if (userPeriodEnd <= 0) {
            return true;
        }
        
        // Upgrade durumunda bilgi göster
        if (item.package_type > userPackageType && userPeriodEnd >= 30) {
            return true;
        }
        
        return false;
    },

    // Fiyat bilgi metni
    getPriceInfoText(item) {
        const userPackageType = this.userData.package_type || 0;
        const userPeriodEnd = this.userData.period_end || 0;
        
        if (userPackageType === 0) {
            return this.$t('trial_to_full_conversion');
        }
        
        if (userPeriodEnd <= 0) {
            return this.$t('expired_renewal_price');
        }
        
        if (item.package_type > userPackageType && userPeriodEnd >= 30) {
            return this.$t('upgrade_difference_price');
        }
        
        return this.$t('full_price');
    },

    // Tooltip metni
    getPriceTooltipText(item) {
        const userPackageType = this.userData.package_type || 0;
        const userPeriodEnd = this.userData.period_end || 0;
        
        if (userPackageType === 0) {
            return this.$t('trial_to_full_conversion_description');
        }
        
        if (userPeriodEnd <= 0) {
            return this.$t('expired_renewal_price_description');
        }
        
        if (item.package_type > userPackageType && userPeriodEnd >= 30) {
            return this.$t('upgrade_difference_price_description');
        }
        
        return this.$t('full_price_description');
    },

    // Fiyat durumu belirleme
    getPriceStatus(item) {
        const userPackageType = this.userData.package_type || 0;
        const userPeriodEnd = this.userData.period_end || 0;
        
        if (userPackageType === 0) {
            return {
                type: 'trial_conversion',
                label: this.$t('trial_to_full_conversion'),
                class: 'badge-light-success',
                icon: 'bi-star'
            };
        }
        
        if (userPeriodEnd <= 0) {
            return {
                type: 'renewal',
                label: this.$t('expired_renewal_price'),
                class: 'badge-light-warning',
                icon: 'bi-arrow-clockwise'
            };
        }
        
        if (item.package_type > userPackageType && userPeriodEnd >= 30) {
            return {
                type: 'upgrade',
                label: this.$t('upgrade_difference_price'),
                class: 'badge-light-info',
                icon: 'bi-arrow-up'
            };
        }
        
        return {
            type: 'full',
            label: this.$t('full_price'),
            class: 'badge-light-secondary',
            icon: 'bi-tag'
        };
    },

    // Dinamik CSS class belirleme
    getPriceDisplayClass(item) {
        const status = this.getPriceStatus(item);
        return {
            'price-trial': status.type === 'trial_conversion',
            'price-renewal': status.type === 'renewal',
            'price-upgrade': status.type === 'upgrade',
            'price-full': status.type === 'full'
        };
    },

    // KDV bilgilerini getir
    getVatInfo() {
        if (this.activeView === 'upgradePlan' && this.selectedLicence) {
            return {
                is_add_vat: this.selectedLicence.is_add_vat,
                vat_rate: parseInt(this.selectedLicence.vat_rate)
            };
        } else {
            return {
                is_add_vat: this.userData.is_add_vat,
                vat_rate: parseInt(this.userData.vat_rate)
            };
        }
    },

    // Ödeme periyodunu getir
    getPaymentPeriod() {
        if (this.activeView === 'upgradePlan' && this.selectedLicence) {
            return Math.ceil(parseInt(this.selectedLicence.period_day) / 30);
        }
        return Math.ceil(parseInt(this.userData.period_end) / 30);
    },

    // Periyot günlerini getir
    getPeriodDays() {
        if (this.activeView === 'upgradePlan' && this.selectedLicence) {
            return this.selectedLicence.period_day;
        }
        return this.userData.period_end;
    },

    // Sonraki adıma geç
    onNextStep(viewType) {
        if (viewType) {
            this.activeView = viewType;
        }
        this.activeStep++;
        
        // Adım bazlı özel işlemler
        if (this.activeStep == 3) {
            this.getCompanyInfo();
        }
    },

    continueToNext() {
        if (!this.canContinue) return;
        
        this.isProcessing = true;
        
        setTimeout(() => {
            this.onNextStep();
            this.isProcessing = false;
        }, 500);
    },

    goBackStep() {
        this.activeStep--;
        if (this.activeStep == 0) {
            this.activeView = null;
            this.selectedLicence = null;
        }
    },

    // Toplam fiyat hesaplama
    calculateGrandTotal() {
        if (this.activeView === 'upgradePlan' && this.selectedLicence) {
            let planPrice = 0;
            
            if (this.activePriceView === 'monthly') {
                // Aylık fiyat
                planPrice = this.shouldUseDifferencePrice(this.selectedLicence) ? 
                    parseFloat(this.selectedLicence.calculated_price_monthly || 0) : 
                    parseFloat(this.selectedLicence.total_calculated_price_monthly || 0);
            } else {
                // Yıllık fiyat
                planPrice = this.shouldUseDifferencePrice(this.selectedLicence) ? 
                    parseFloat(this.selectedLicence.calculated_price || 0) : 
                    parseFloat(this.selectedLicence.total_calculated_price || 0);
            }
            
            this.totals.sub_total = planPrice.toFixed(2);
            
            // KDV hesaplama
            if (this.selectedLicence.is_add_vat == 1) {
                this.totals.vat_amount = (parseFloat(this.totals.sub_total) * parseFloat(this.selectedLicence.vat_rate) / 100).toFixed(2);
            } else {
                this.totals.vat_amount = '0.00';
            }
            
            this.totals.grand_total = (parseFloat(this.totals.sub_total) + parseFloat(this.totals.vat_amount)).toFixed(2);
            
            if (this.activePriceView === 'monthly') {
                this.totals.monthly_price_total = this.totals.grand_total;
            }
            
        } else if (this.activeView === 'addUser') {
            this.totals.sub_total = this.upgradeForm.user_total;
            
            if (this.userData.is_add_vat == 1) {
                this.totals.vat_amount = (parseFloat(this.totals.sub_total) * parseFloat(this.userData.vat_rate) / 100).toFixed(2);
            } else {
                this.totals.vat_amount = '0.00';
            }
            
            this.totals.grand_total = (parseFloat(this.totals.sub_total) + parseFloat(this.totals.vat_amount)).toFixed(2);
        }
    },

    // Şirket bilgilerini getir
    async getCompanyInfo() {
        try {
            const parameters = {
                session_id: this.$getUser().session_id
            };
            
            const response = await axios.post('/api/Lic/GetCompanyInfo', parameters, {'Content-Type': 'application/json'});
            
            if (!response.data.error) {
                this.companyInfo = response.data;
            }
        } catch (error) {
            console.error(error);
        }
    },

    // Fatura adresi düzenlemeyi aç/kapat
    onEditBillingAddress() {
        this.isEditBillingAddress = true;
        this.billingForm = { ...this.companyInfo };
    },

    // Fatura adresi düzenlemeyi iptal et
    cancelEditBillingAddress() {
        this.isEditBillingAddress = false;
        this.billingForm = { ...this.companyInfo };
    },

    // Fatura adresini kaydet
    async saveBillingAddress() {
        try {
            const parameters = {
                ...this.billingForm,
                session_id: this.$getUser().session_id
            };
            
            const response = await axios.post('/api/Lic/SaveCompanyInfo', parameters, {'Content-Type': 'application/json'});
            
            if (!response.data.error) {
                this.isEditBillingAddress = false;
                await this.getCompanyInfo();
            }
        } catch (error) {
            console.error(error);
        }
    },

    onSelectAddress(item) {
        this.billingForm.company_address = item.fullAddress;
        this.billingForm.company_city = item.town_or_city;
        this.billingForm.company_district = item.district;
        this.billingForm.company_postcode = item.postcode;
    },

    async startTransaction() {
        if (!this.canContinue) return;
        
        this.isProcessing = true;
        
        try {
            const parameters = {
                session_id: this.$getUser().session_id,
                target_licence_id: this.selectedLicence ? this.selectedLicence.id : null,
                add_user_count: this.activeView === 'addUser' ? this.upgradeForm.user_count : 0,
                payment_type: this.activePriceView === 'monthly' ? 1 : 2,
                payment_method: this.upgradeForm.payment_method,
                quantity: parseFloat(this.totals.grand_total),
                email: this.$getUser().user_mail
            };
            
            const response = await axios.post('/api/Lic/AddLicenceTransaction', parameters, {'Content-Type': 'application/json'});
            
            if (!response.data.error) {
                this.licenceReferenceNumber = response.data.LicenceSID;
                this.licenceTransactionId = response.data.LicenceTransactionID;
                this.stripeData.strsid = response.data.StrSID;
                
                // Kullanıcı session'ını güncelle
                this.updateUserSession();
                
                // Havale ödeme ise banka bilgilerini al
                if (this.upgradeForm.payment_method == 2) {
                    await this.getBankTransferDetails();
                }
                
                this.activeStep++;
            }
            
        } catch (error) {
            console.error(error);
        } finally {
            this.isProcessing = false;
        }
    },

    // Ödeme işlemini gerçekleştir
    async processPayment() {
        this.isProcessing = true;
        
        try {
            // Stripe checkout'a yönlendir
            if (this.$refs.checkoutRef) {
                this.$refs.checkoutRef.redirectToCheckout();
            } else {
                // Fallback: Manuel işlem
                setTimeout(() => {
                    this.activeStep = 5;
                    this.isProcessing = false;
                }, 2000);
            }
            
        } catch (error) {
            console.error(error);
            this.isProcessing = false;
        }
    },
    // İşlemi tamamla
    completeTransaction() {
        this.activeStep = 5;
        
        setTimeout(() => {
            if (this.$route.name == 'Home') {
                this.$router.go(0);
            } else {
                this.$router.push({ name: 'Home' });
            }
        }, 3000);
    },

    // İşlemi iptal et
    async cancelTransaction() {
        try {
            const result = await this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_cancel_this_request'),
                confirmButtonColor: "#f1416c",
                showCancelButton: true,
                cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('cancel_request'),
                icon: 'info'
            });
            
            if (result.isConfirmed) {
                this.isProcessing = true;
                
                const params = {
                    session_id: this.$getUser().session_id, 
                    transaction_id: this.licenceTransactionId
                };
                
                const response = await axios.post('api/Lic/CancelLicenceRequest', params, {'Content-Type': 'application/json'});
                
                if (!response.data.error) {
                    this.$router.push({ name: 'Home' });
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.isProcessing = false;
        }
    },

    // Kullanıcı session'ını güncelle
    updateUserSession() {
        try {
            const userData = ls.get('user_' + sessionStorage.getItem('sid'));
            if (userData) {
                userData.is_pending_licence_exist = 1;
                ls.set('user_' + sessionStorage.getItem('sid'), userData);
            }
        } catch (error) {
            console.error(error);
        }
    },

    // Havale detaylarını al
    async getBankTransferDetails() {
        try {
            const parameters = {
                session_id: this.$getUser().session_id
            };
            
            const response = await axios.post('/api/Lic/GetLicenceBankDescription', parameters, {'Content-Type': 'application/json'});
            this.bankDescription = response.data;
            
        } catch (error) {
            console.error(error);
        }
    },

    // Panoya kopyala
    async copyToClipboard() {
        try {
            const text = this.licenceReferenceNumber;
            
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
                this.showCopied();
                return;
            }

            // Eski tarayıcılar için yedek yöntem
            const el = this.$refs.referenceNumber;
            const range = document.createRange();
            range.selectNode(el);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');
            this.showCopied();
            selection.removeAllRanges();
            
        } catch (error) {
            console.error(error);
        }
    },

    // Kopyalama başarı göstergesi
    showCopied() {
        this.isCopied = true;
        setTimeout(() => {
            this.isCopied = false;
        }, 2000);
    },

    
    onCompletePayment(item) {
        this.userMail = this.$getUser().user_mail;
        this.stripeData.strsid = item.stripe_session_id;
        this.licenceList = [];
        this.licenceDetails = {
            parameter_type_name: item.description,
            period_day: item.period_day
        };
        this.upgradeForm.user_count = item.user_count;
        this.activeStep = 4;
        this.activePriceView = item.payment_type == 1 ? 'monthly' : 'annual';
        this.upgradeForm.payment_method = 1;
        this.totals.grand_total = item.grand_total;
        this.totals.monthly_price_total = item.grand_total;
    },

    // Yardım sayfası kontrolü
    async checkHelpPageView() {
        try {
            const parameters = {
                session_id: this.$getUser().session_id,
                menu_selection: '/LicenceGuideHelppage'
            };
            
            const response = await axios.post('api/HelpPage/HelpPagesContent', parameters, {'Content-Type': 'application/json'});
            
            if (!response.data.error) {
                this.isViewLicenceGuid = response.data;
            }
        } catch (error) {
            console.error(error);
        }
    },

    // Yardım sayfasını aç
    async openHelpPage() {
        try {
            const parameters = {
                session_id: this.$getUser().session_id,
                menu_selection: '/LicenceGuideHelppage'
            };
            
            await axios.post('api/HelpPage/GetPageContents', parameters, {'Content-Type': 'application/json'});
            window.open('/LicenceGuideHelppage');
            
        } catch (error) {
            console.error(error);
        }
    },

    // Form sıfırlama
    resetForm() {
        this.upgradeForm = {
            licence_id: null,
            user_count: 0,
            user_total: 0,
            payment_method: 1,
            subtotal: 0
        };
        
        this.totals = {
            sub_total: 0.00,
            vat_amount: 0.00,
            grand_total: 0.00,
            monthly_price_total: 0.00
        };
        
        this.companyInfo = {};
        this.billingForm = {
            primary_person: null,
            company_country_code: '-1',
            phone_country_code: null,
            company_gsm: null,
            company_email: null,
            company_postcode: null,
            company_address: null,
            company_city: null,
            company_district: null
        };
        
        this.selectedLicence = null;
        this.isProcessing = false;
        this.isEditBillingAddress = false;
        this.activePriceView = 'monthly';        
        this.activeStep = 0;
        this.activeView = null;
    },

    // Komponenti başlat
    initializeComponent() {
        this.resetForm();
        this.getData();
    },

    async updateSubscriptionPrice() {
        try {
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_upgrade_subscription'),
                confirmButtonColor: "#50cd89",
                showDenyButton: false,
                showCancelButton: true,
                cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
            })
            .then((result) => {
                if (result.isConfirmed) {            
                    this.isProcessing = true;
                    const parameters = {
                        session_id: this.$getUser().session_id,
                        price: this.upgradeForm.user_count > 0 ? this.upgradeForm.user_total : this.totals.grand_total,
                        user_count: this.upgradeForm.user_count,
                        target_licence_id: this.selectedLicence ? this.selectedLicence.id : null,
                        payment_method: this.upgradeForm.payment_method
                    };
                    axios.post('/api/Payment/UpdateSubscription', parameters, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                            this.activeStep = 5;
                            setTimeout(() => {
                                this.$signOutWithTimer(this.$t('we-received-your-request'), this.$t('subscription_updated_succesfully'));
                            }, 3000);
                        }
                    })
                    .catch(function (error) {
                       console.error(error);
                    });
                }
            });
        } catch (error) {
            console.error('Subscription update error:', error);
            this.$swal(this.$t('error'), this.$t('subscription_update_failed'), 'error');
        } finally {
            this.isProcessing = false;
        }
    }
  },

  // Watchers
  watch: {
    selectedLicence: {
        handler(newVal) {
            if (newVal) {
                this.calculateGrandTotal();
            }
        },
        deep: true
    },
    
    'upgradeForm.user_count': {
        handler() {
            if (this.activeView === 'addUser') {
                this.calculateUserTotal();
            }
        }
    },
    
    activePriceView: {
        handler() {
            this.calculateGrandTotal();
        }
    },

    'upgradeForm.payment_method': {
        handler() {
            if (this.upgradeForm.payment_method == 2 && this.activePriceView == 'monthly') {
                this.activePriceView = 'annual';
            }
        }
    }
  }
};
</script>

<style scoped>
/* Özel stiller */
.card.hover-elevate-up:hover {
    transform: translateY(-5px);
    transition: transform 0.3s ease-in-out;
}

.ribbon-label {
    font-size: 0.75rem;
    font-weight: 600;
}

.nav-group .btn.active {
    background-color: var(--bs-primary);
    color: white;
}

.stepper .current {
    opacity: 1;
}

.stepper .current ~ * {
    opacity: 0.7;
}

/* Plan kartları için özel stiller */
.plan-card {
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.plan-card:hover {
    border-color: var(--bs-primary);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}

.plan-card.selected {
    border-color: var(--bs-success);
    background-color: rgba(80, 205, 137, 0.05);
}

/* Fiyat gösterim alanı */
.price-display {
    background: linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-info) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* Kullanıcı sayacı */
.user-counter .btn {
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-counter input {
    max-width: 80px;
    text-align: center;
}

/* Badge stilleri */
.badge.badge-light-success {
    background-color: rgba(80, 205, 137, 0.1);
    color: #50cd89;
}

.badge.badge-light-warning {
    background-color: rgba(255, 199, 0, 0.1);
    color: #ffc700;
}

/* Form kontrolleri */
.form-control:focus {
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.25);
}

/* Loading spinner özelleştirmesi */
.spinner-border-sm {
    width: 1rem;
    height: 1rem;
}

/* Responsive düzenlemeler */
@media (max-width: 768px) {
    .col-xl-4 {
        margin-bottom: 1rem;
    }
    
    .fs-3x {
        font-size: 2rem !important;
    }
    
    .user-counter {
        flex-direction: column;
        gap: 0.5rem;
    }
    
    .user-counter input {
        order: 2;
        margin: 0 0.5rem;
    }
}

/* Animasyonlar */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.card {
    animation: fadeInUp 0.5s ease-out;
}

/* Ödeme yöntemi seçim kartları */
.btn-outline.active {
    border-width: 2px;
    font-weight: 600;
}

/* Fatura bilgileri kartı */
.card-dashed {
    border-style: dashed;
    border-width: 2px;
}

/* Buton hover efektleri */
.btn:hover {
    transform: translateY(-1px);
    transition: transform 0.2s ease;
}

.btn:active {
    transform: translateY(0);
}

/* Kart shadow efektleri */
.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-sm:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

/* İkon stilleri */
.bi {
    vertical-align: -0.125em;
}

/* Input grup stilleri */
.input-group-text {
    background-color: var(--bs-light);
    border-color: var(--bs-border-color);
}

/* Tablo responsive */
.table-responsive {
    border-radius: 0.5rem;
}

/* Separator stilleri */
.separator {
    height: 1px;
    background-color: var(--bs-border-color);
    margin: 1rem 0;
}

/* Progress indicator */
.indicator-progress {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

/* Fiyat durumlarına göre stil */
.price-trial {
    border-left: 4px solid #50cd89;
    background: linear-gradient(135deg, rgba(80, 205, 137, 0.1) 0%, rgba(80, 205, 137, 0.05) 100%);
}

.price-renewal {
    border-left: 4px solid #ffc700;
    background: linear-gradient(135deg, rgba(255, 199, 0, 0.1) 0%, rgba(255, 199, 0, 0.05) 100%);
}

.price-upgrade {
    border-left: 4px solid #009ef7;
    background: linear-gradient(135deg, rgba(0, 158, 247, 0.1) 0%, rgba(0, 158, 247, 0.05) 100%);
}

.price-full {
    border-left: 4px solid #7e8299;
    background: linear-gradient(135deg, rgba(126, 130, 153, 0.1) 0%, rgba(126, 130, 153, 0.05) 100%);
}

/* Badge stilleri */
.badge-light-success {
    background-color: rgba(80, 205, 137, 0.1);
    color: #50cd89;
    border: 1px solid rgba(80, 205, 137, 0.2);
}

.badge-light-warning {
    background-color: rgba(255, 199, 0, 0.1);
    color: #ffc700;
    border: 1px solid rgba(255, 199, 0, 0.2);
}

.badge-light-info {
    background-color: rgba(0, 158, 247, 0.1);
    color: #009ef7;
    border: 1px solid rgba(0, 158, 247, 0.2);
}

.badge-light-secondary {
    background-color: rgba(126, 130, 153, 0.1);
    color: #7e8299;
    border: 1px solid rgba(126, 130, 153, 0.2);
}

/* Fiyat bilgi konteyneri */
.price-info-container {
    position: relative;
    text-align: center;
    padding: 1rem;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
}

.price-info-container:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.price-label {
    margin-top: 0.5rem;
}

/* Animasyonlar */
@keyframes priceHighlight {
    0% { background-color: transparent; }
    50% { background-color: rgba(0, 158, 247, 0.1); }
    100% { background-color: transparent; }
}

.price-highlight {
    animation: priceHighlight 2s ease-in-out;
}


/* Bu CSS'i style bölümüne ekleyin */
.price-info-container {
    position: relative;
    padding: 1rem 0;
}

.price-tooltip {
    cursor: help;
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.price-tooltip:hover {
    opacity: 1;
}

.cursor-help {
    cursor: help;
}

</style>